import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { mergeEntity, mergeEntities } from '@utils/object.js'

export const initialState = {}

export const timespan = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_TIMESPAN, (state, action) => receiveTimespan(state, action))
    .addCase(ActionTypes.RECEIVE_TIMESPANS, (state, action) => receiveTimespans(state, action))
    .addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
    .addCase(ActionTypes.REMOVE_ENTITY, (state, action) => removeEntity(state, action))
})

export default timespan

function getDefaultAttributes() {
  return {
    id: 0,
    timeline_id: 0,
    title: '',
    description: '',
    start_date: '1978-12-24 00:00:00',
    end_date: '1978-12-25 00:00:00',
  }
}

function receiveTimespan(state, action) {
  const { payload: timespan } = action
  return mergeEntity(state, timespan, getDefaultAttributes())
}

function receiveTimespans(state, action) {
  const { payload: timespans } = action
  return mergeEntities(state, timespans, getDefaultAttributes())
}

function receiveEntities(state, action) {
  const { payload } = action
  if (payload.hasOwnProperty('timespan')) {
    const { timespan } = payload
    state = mergeEntity(state, timespan, getDefaultAttributes())
  }
  if (payload.hasOwnProperty('timespans')) {
    const { timespans } = payload
    state = mergeEntities(state, timespans, getDefaultAttributes())
  }
  return state
}

function removeEntity(state, action) {
  const { payload } = action
  const { entityId, entityType } = payload
  if (entityType === 'timespan') {
    delete state[entityId]
  }
  return state
}
